import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { QueryKey } from "../types/enums/QueryKey.enum"
import { GetAlertaUsuariosInfo, VerificarExistenAlertas } from "../services/ApiConsultaGestionCasos/Actividades.service"
import type { AlertasByUsuarioRequest, DataLeida, DataNoLeida, VerificarExistenAlertasResponse } from "../types/interfaces/ApiConsultaGestionCasos/Actividades.interface"
import type { ApiError } from "../types/interfaces/Source"
import type { AlertaLeidaRequest, AlertasLeidasRequest } from "../types/interfaces/ApiCasos/Alertas.interface"
import { AlertaLeida, AlertasLeidas } from "../services/ApiCasos/Alertas.service"
import { format, isToday, isYesterday, parseISO } from "date-fns";
import { es } from "date-fns/locale";

export const useVerificarExistenAlertas = (data: AlertasByUsuarioRequest) => {
    return useQuery<VerificarExistenAlertasResponse>({
        queryKey: [QueryKey.VerificarExistenAlertas],
        queryFn: async () => await VerificarExistenAlertas(data),
        refetchOnWindowFocus: true,
        staleTime: 300000, // 5 minutos en milisegundos
    })
}

export const useGetAlertaUsuariosInfo = (data: AlertasByUsuarioRequest) => {
    return useQuery({
        queryKey: [QueryKey.GetAlertaUsuariosInfo],
        queryFn: async () => await GetAlertaUsuariosInfo(data),
        refetchOnWindowFocus: true,
        //staleTime: 300000, // 5 minutos en milisegundos
        //enabled: !!existenAlertas,
        //enabled: !!data.idUsuarioLogeado //&& !!data.idRelUsuarioEntidades //&& !!data.idRol,
    })
}

export const useMarcarAlertasLeidas = () => {
    
    const queryClient = useQueryClient();
    
    return useMutation<any, ApiError, AlertasLeidasRequest>({
        mutationFn: (data: AlertasLeidasRequest) => AlertasLeidas(data),
        onError: (err) => {
            console.log(err)
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ 
                queryKey: [QueryKey.VerificarExistenAlertas] 
            });
            queryClient.invalidateQueries({ 
                queryKey: [QueryKey.GetAlertaUsuariosInfo] 
            });
        }
    })
}

export const useMarcarAlertaLeida = () => {

    const queryClient = useQueryClient();
    
    return useMutation<any, ApiError, AlertaLeidaRequest>({
        mutationFn: (data: AlertaLeidaRequest) => AlertaLeida(data),
        onError: (err) => {
            console.log(err)
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ 
                queryKey: [QueryKey.VerificarExistenAlertas] 
            });
            queryClient.invalidateQueries({ 
                queryKey: [QueryKey.GetAlertaUsuariosInfo] 
            });
        }
    })
}

export const useGroupNotificationsByDate = (alertas: DataNoLeida[] | DataLeida[]): Record<string, DataNoLeida[]> => {
    if (!alertas || alertas.length === 0) return {};

    return alertas
        .slice()
        .sort(
            (a: any, b: any) =>
                new Date(b.FechaAlerta).getTime() -
                new Date(a.FechaAlerta).getTime()
        )
        .reduce((groups: any, alerta: any) => {
            const fecha = parseISO(alerta.FechaAlerta);

            let dateKey = format(fecha, "PPP", { locale: es });

            if (isToday(fecha)) dateKey = "Hoy";
            if (isYesterday(fecha)) dateKey = "Ayer";

            if (!groups[dateKey]) groups[dateKey] = [];
            groups[dateKey].push(alerta);
            return groups;
        }, {} as Record<string, DataNoLeida[]>);
};